export default __webpack_public_path__ + "static/media/powered-ab.ae3ae1b4.png";